module.exports = __webpack_public_path__ + "media/images/clear-check-blue-7f875e6e4555b54ed014c7385aa9b918.svg";